(function () {
  'use strict';

  /* ============================================================
     1. HIDE HEADER ON SCROLL DOWN, SHOW ON SCROLL UP
     ============================================================ */
  (function initScrollHeader() {
    const header = document.querySelector(
      '.header, .header-wrapper, .site-header, header[role="banner"], #shopify-section-header'
    );
    if (!header) return;

    header.style.willChange = 'transform';
    header.style.backfaceVisibility = 'hidden';

    let lastScrollY = window.scrollY;
    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY && currentScrollY > 80) {
            header.classList.add('header--hidden');
          } else {
            header.classList.remove('header--hidden');
          }
          lastScrollY = currentScrollY;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ============================================================
     2. DRAGGABLE & TOUCH SLIDERS (Hero & Lookbook)
     ============================================================ */
  function makeSliderDraggable(containerId, trackId, prevId, nextId) {
    const container = document.getElementById(containerId);
    const track = document.getElementById(trackId);
    if (!container || !track) return;

    const prevBtn = document.getElementById(prevId);
    const nextBtn = document.getElementById(nextId);

    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;
    let currentIndex = 0;
    const slides = Array.from(track.children);
    if (!slides.length) return;

    function dragStart(e) {
      isDragging = true;
      startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      container.classList.add('is-dragging');
      animationID = requestAnimationFrame(animation);
    }

    function dragMove(e) {
      if (!isDragging) return;
      const currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      const diff = currentX - startX;
      currentTranslate = prevTranslate + diff;
    }

    function dragEnd() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      container.classList.remove('is-dragging');

      const movedBy = currentTranslate - prevTranslate;
      if (movedBy < -100 && currentIndex < slides.length - 1) {
        currentIndex++;
      } else if (movedBy > 100 && currentIndex > 0) {
        currentIndex--;
      }

      setPositionByIndex();
    }

    function animation() {
      setTrackPosition();
      if (isDragging) requestAnimationFrame(animation);
    }

    function setTrackPosition() {
      track.style.transform = `translateX(${currentTranslate}px)`;
    }

    function setPositionByIndex() {
      if (!slides[0]) return;
      const slideWidth = slides[0].offsetWidth;
      currentTranslate = currentIndex * -slideWidth;
      prevTranslate = currentTranslate;
      track.style.transform = `translateX(${currentTranslate}px)`;
    }

    container.addEventListener('mousedown', dragStart);
    container.addEventListener('mousemove', dragMove);
    window.addEventListener('mouseup', dragEnd);

    container.addEventListener('touchstart', dragStart, { passive: true });
    container.addEventListener('touchmove', dragMove, { passive: true });
    container.addEventListener('touchend', dragEnd);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          setPositionByIndex();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentIndex < slides.length - 1) {
          currentIndex++;
          setPositionByIndex();
        }
      });
    }

    window.addEventListener('resize', setPositionByIndex);
  }

  // Initialize sliders
  setTimeout(function () {
    makeSliderDraggable('kottniHeroSlider', 'kottniSliderTrack', 'kottniSliderPrev', 'kottniSliderNext');
    makeSliderDraggable('kottniLookbookTrackWrap', 'kottniLookbookTrack', 'kottniLookbookPrev', 'kottniLookbookNext');
  }, 300);

  /* ============================================================
     3. SCROLL REVEAL (Soft fade-in for product grid/banners)
     ============================================================ */
  (function initScrollReveal() {
    const style = document.createElement('style');
    style.textContent = `
      .kottni-reveal {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
      }
      .kottni-reveal.visible {
        opacity: 1;
        transform: translateY(0);
      }
    `;
    document.head.appendChild(style);

    const targets = document.querySelectorAll(
      '.shopify-section, .kottni-grid__item, .kottni-cats__item, .kottni-split__item, .kottni-editorial__container, .kottni-video'
    );

    targets.forEach(function (el) {
      el.classList.add('kottni-reveal');
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -20px 0px'
    });

    targets.forEach(function (el) {
      observer.observe(el);
    });
  })();

  /* ============================================================
     4. QUICK-ADD SIZE PANEL FOR SHOPIFY
     ============================================================ */
  (function initQuickAdd() {
    setTimeout(function () {
      const cards = document.querySelectorAll(
        '.card-wrapper, product-card, li.grid__item, .kottni-grid__item'
      );

      cards.forEach(function (card) {
        const mediaEl = card.querySelector('.card__media, .media, .product-media-container, .kottni-grid__media');
        if (!mediaEl) return;
        if (card.querySelector('.kottni-trigger-btn')) return;

        const productUrl = card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';

        // Add shopping bag quick-add button
        const triggerBtn = document.createElement('button');
        triggerBtn.className = 'kottni-trigger-btn';
        triggerBtn.setAttribute('aria-label', 'Quick add to cart');
        // Professional shopping bag SVG icon
        triggerBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>`;
        mediaEl.style.position = 'relative';
        mediaEl.appendChild(triggerBtn);

        // Add size slide-up panel
        const panel = document.createElement('div');
        panel.className = 'kottni-quick-add';
        panel.innerHTML = `
          <div class="kottni-quick-add__title">SELECT SIZE</div>
          <div class="kottni-quick-add__sizes"></div>
          <button class="kottni-quick-add__btn">ADD TO BAG</button>
        `;
        mediaEl.appendChild(panel);

        const sizesContainer = panel.querySelector('.kottni-quick-add__sizes');
        const defaultSizes = ['S', 'M', 'L', 'XL'];
        defaultSizes.forEach(function (size) {
          const btn = document.createElement('button');
          btn.className = 'kottni-quick-add__size';
          btn.type = 'button';
          btn.textContent = size;
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            sizesContainer.querySelectorAll('.kottni-quick-add__size').forEach(function (b) {
              b.classList.remove('selected');
            });
            btn.classList.add('selected');
          });
          sizesContainer.appendChild(btn);
        });

        // Add to cart click
        const addBtn = panel.querySelector('.kottni-quick-add__btn');
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const selected = sizesContainer.querySelector('.selected');
          if (!selected) {
            panel.style.animation = 'kottni-shake 0.3s ease';
            setTimeout(function () { panel.style.animation = ''; }, 300);
            return;
          }
          if (productUrl) {
            window.location.href = productUrl;
          }
        });

        panel.addEventListener('click', function (e) { e.stopPropagation(); });
        triggerBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          document.querySelectorAll('.kottni-quick-add.active').forEach(function (o) {
            if (o !== panel) o.classList.remove('active');
          });
          panel.classList.toggle('active');
        });

        card.addEventListener('mouseleave', function () {
          panel.classList.remove('active');
        });
      });

      // Shake animation
      const style = document.createElement('style');
      style.textContent = `
        @keyframes kottni-shake {
          0%, 100% { transform: translateX(0); }
          25%       { transform: translateX(-4px); }
          75%       { transform: translateX(4px); }
        }
      `;
      document.head.appendChild(style);
    }, 1000);
  })();

  /* ============================================================
     5. STICKY "BACK TO TOP" BUTTON
     ============================================================ */
  (function initBackToTop() {
    const btn = document.createElement('button');
    btn.className = 'kottni-back-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"/>
      </svg>
    `;
    document.body.appendChild(btn);

    window.addEventListener('scroll', function () {
      if (window.scrollY > 500) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  // Policies section removed

})();
